<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <g v-if="weight === 'THIN'" mask="url(#mask-thin)">
            <path
                d="M13.5 9V4H20V9H13.5ZM4 12V4H10.5V12H4ZM13.5 20V12H20V20H13.5ZM4 20V15H10.5V20H4ZM5 11H9.5V5H5V11ZM14.5 19H19V13H14.5V19ZM14.5 8H19V5H14.5V8ZM5 19H9.5V16H5V19Z"
                fill="currentColor"
            />
            <mask id="mask-thin" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <!-- REGULAR -->
        <g v-else-if="weight === 'REGULAR'" mask="url(#mask-regular)">
            <path
                d="M13.25 9V3.5H20.5V9H13.25ZM3.5 12.5V3.5H10.75V12.5H3.5ZM13.25 20.5V11.5H20.5V20.5H13.25ZM3.5 20.5V15H10.75V20.5H3.5ZM5 11H9.25V5H5V11ZM14.75 19H19V13H14.75V19ZM14.75 7.5H19V5H14.75V7.5ZM5 19H9.25V16.5H5V19Z"
                fill="currentColor"
            />
            <mask id="mask-regular" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <!-- FILL -->
        <g v-else mask="url(#mask-fill)">
            <path
                d="M13.25 9V3.5H20.5V9H13.25ZM3.5 12.5V3.5H10.75V12.5H3.5ZM13.25 20.5V11.5H20.5V20.5H13.25ZM3.5 20.5V15H10.75V20.5H3.5Z"
                fill="currentColor"
            />
            <mask id="mask-fill" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'dashboard-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>